/**
 * Landing page (post-login home) preference.
 * Values match App.js currentView ids.
 */

export const DEFAULT_LANDING_VIEW = 'dashboard';

/** All allowed landing views (server allowlist). */
export const ALL_LANDING_VIEWS = [
  { id: 'dashboard', label: 'Dashboard' },
  { id: 'devices', label: 'Devices' },
  { id: 'assigned-devices', label: 'My Devices' },
  { id: 'complaints', label: 'Complaints' },
  { id: 'alerts', label: 'Alerts' },
  { id: 'analytics', label: 'Analytics' },
  { id: 'approvals', label: 'Approvals' },
  { id: 'location-transfers', label: 'Location Transfers' },
  { id: 'department-transfers', label: 'Department Transfers' },
  { id: 'maintenance-history', label: 'Maintenance' },
  { id: 'work-logs', label: 'My Work Logs' },
  { id: 'users', label: 'Users' },
  { id: 'settings', label: 'Settings' },
  { id: 'audit-viewer', label: 'Audit Trail' },
  { id: 'data-import', label: 'Data Import' },
  { id: 'locations', label: 'Locations' },
  { id: 'departments', label: 'Departments' },
  { id: 'device-names', label: 'Device Names' },
  { id: 'system-controls', label: 'System Controls' },
];

/** Ordered options each role may choose as landing page. */
const LANDING_BY_ROLE = {
  technician: [
    'dashboard',
    'assigned-devices',
    'work-logs',
    'maintenance-history',
    'complaints',
    'alerts',
    'location-transfers',
  ],
  central_help_desk: [
    'dashboard',
    'complaints',
    'alerts',
    'devices',
  ],
  coordinator: [
    'dashboard',
    'devices',
    'complaints',
    'alerts',
    'analytics',
  ],
  custodian: [
    'dashboard',
    'devices',
    'complaints',
    'alerts',
    'analytics',
    'department-transfers',
  ],
  manager: [
    'dashboard',
    'devices',
    'complaints',
    'alerts',
    'analytics',
    'location-transfers',
  ],
  admin: [
    'dashboard',
    'devices',
    'complaints',
    'alerts',
    'analytics',
    'approvals',
    'location-transfers',
    'users',
    'settings',
    'audit-viewer',
    'data-import',
  ],
  superadmin: [
    'dashboard',
    'locations',
    'devices',
    'complaints',
    'alerts',
    'analytics',
    'users',
    'departments',
    'device-names',
    'data-import',
    'audit-viewer',
    'system-controls',
  ],
};

export function isValidLandingView(id) {
  return ALL_LANDING_VIEWS.some((v) => v.id === id);
}

export function getLandingViewsForRole(role) {
  const ids = LANDING_BY_ROLE[role] || ['dashboard'];
  return ids
    .map((id) => ALL_LANDING_VIEWS.find((v) => v.id === id))
    .filter(Boolean);
}

/**
 * Resolve a stored preference to a view the role can open.
 * Falls back to dashboard if missing or not allowed for role.
 */
export function resolveLandingView(preferred, role) {
  const options = getLandingViewsForRole(role);
  if (preferred && options.some((o) => o.id === preferred)) {
    return preferred;
  }
  return DEFAULT_LANDING_VIEW;
}
